import { BoxProps } from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Typography from '../../../../../../shared/library/Typography';
import { StyledExpandLessIcon, StyledWrapper } from './styles';

export default function CardCollapse(props: BoxProps) {
  const { t } = useTranslation();
  const { children, ...restProps } = props;

  return (
    <StyledWrapper {...restProps}>
      <StyledExpandLessIcon fontSize="large" />
      {children || (
        <Typography variant="subtitle2" opacity={0.7}>
          {t(
            'site.pricing.products-selection.primary-product-card.button.collapse.label',
          )}
        </Typography>
      )}
    </StyledWrapper>
  );
}
